var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup535(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.04,
    height: 40,
    viewBox: "0 0 40.04 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(523.526 -95.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M-498.254,117.413l2.624,2.578-3.279,3.234-2.576-2.581a13.915,13.915,0,0,1-12.322,1.933,13.6,13.6,0,0,1-7.641-5.965,13.91,13.91,0,0,1,2.6-17.709,14.023,14.023,0,0,1,17.877-.52A14.022,14.022,0,0,1-498.254,117.413Zm-11.425,2.321a10.4,10.4,0,0,0,10.4-10.43,10.384,10.384,0,0,0-10.429-10.39A10.382,10.382,0,0,0-520.1,109.347,10.451,10.451,0,0,0-509.679,119.734Z",
    transform: "translate(0 0)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M-191.126,432.039a3.507,3.507,0,0,1-2.8-1.072q-3.582-3.539-7.126-7.117a1.545,1.545,0,0,1,.017-2.3q1.907-1.93,3.837-3.837a1.546,1.546,0,0,1,2.3-.018c2.355,2.337,4.725,4.66,7.033,7.044a4.27,4.27,0,0,1-1.3,6.829A3.368,3.368,0,0,1-191.126,432.039Z",
    transform: "translate(-296.815 -296.64)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    d: "M-347.174,179.719c.042.465.024.907-.459,1.149-.595.3-1.185-.121-1.2-.85a6.01,6.01,0,0,0-1.117-3.467,6.159,6.159,0,0,0-5.031-2.685c-.631-.025-.955-.334-.917-.9a.765.765,0,0,1,.858-.754,7.6,7.6,0,0,1,4.869,1.7A7.754,7.754,0,0,1-347.174,179.719Z",
    transform: "translate(-154.534 -70.8)",
    fill: "#7a7a7a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup535);
export default __webpack_public_path__ + "static/media/Group 535.b925b725c0869a53956fd8d7032f3019.svg";
export { ForwardRef as ReactComponent };